// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__350eG","inputWrap":"Table_inputWrap__1LQ86","col":"Table_col__kjVht","bmiTooltip":"Table_bmiTooltip__3m8mn"};